import Button from "./ds/Button";
import PasswordField from "./ds/PasswordField";
import { useState, useEffect } from "react";

const PasswordProtection = ({ children }) => {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");
  const [isDark, setIsDark] = useState(true);

  // Check if already authenticated
  useEffect(() => {
    const savedAuth = localStorage.getItem("site_access");
    const authTimestamp = localStorage.getItem("site_access_timestamp");
    
    if (savedAuth === "granted" && authTimestamp) {
      // Check if session has expired (24 hours = 86400000 milliseconds)
      const expirationTime = 24 * 60 * 60 * 1000; // 24 hours
      const now = Date.now();
      const timeElapsed = now - parseInt(authTimestamp);
      
      if (timeElapsed < expirationTime) {
        setIsAuthenticated(true);
      } else {
        // Session expired, clear storage
        localStorage.removeItem("site_access");
        localStorage.removeItem("site_access_timestamp");
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Change this password to whatever you want
    const correctPassword = "Mintly12345@";
    
    if (password === correctPassword) {
      setIsAuthenticated(true);
      localStorage.setItem("site_access", "granted");
      localStorage.setItem("site_access_timestamp", Date.now().toString());
      setError("");
    } else {
      setError("Incorrect password");
      setPassword("");
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div
      data-theme={isDark ? "dark" : "light"}
      className="flex min-h-screen items-center justify-center bg-bg-base p-space-16 font-ds text-label-primary"
    >
      <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-[420px] flex-col gap-space-20 rounded-radius-xl border border-separator-default bg-bg-raised p-space-32 shadow-overlay"
      >
        <div className="flex items-center gap-space-12">
          <img src="/assets/mintly-logo.png" alt="" className="size-8" />
          <span className="text-title-3">Mintly</span>
        </div>
        <h1 className="text-title-2">Enter Password</h1>
        <PasswordField
          label="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError("");
          }}
          error={error}
          autoFocus
        />
        <Button type="submit" fullWidth>
          Enter
        </Button>
      </form>
    </div>
  );
};

export default PasswordProtection;
